import { Inject, Injectable } from '@angular/core';
import { API_ENDPOINTS, ApiEndpoints, ApiResponse } from '@contracts';
import { ApiCilent } from '@core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(
    private apiClient: ApiCilent,
    @Inject(API_ENDPOINTS)
    private readonly endpoints: ApiEndpoints,
  ) {}
  endpoint = this.endpoints.dashboard;

  getDashboardMDB(query?: any): Observable<ApiResponse<any>> {
    return this.apiClient.get({ ...this.endpoint.get.dashboard_mdb, query });
  }
  getDashboardMDBData(query: any): Observable<ApiResponse<any>> {
    return this.apiClient.get({ ...this.endpoint.get.dashboard_mdb_data, query });
  }
}
